/* Progressive enhancement only; native filtering and purchase forms are unchanged. */
(() => {
 'use strict';
 document.addEventListener('click', event => {
  const button = event.target.closest('[data-catalog-view]');
  if (!button) return;
  const catalog = button.closest('[data-anime-catalog]');
  if (!catalog) return;
  const wide = button.dataset.catalogView === 'wide';
  catalog.classList.toggle('catalog-display-wide', wide);
  catalog.querySelectorAll('[data-catalog-view]').forEach(item => item.setAttribute('aria-pressed', String(item === button)));
 });
})();
